import type { PropsWithChildren } from 'react';

import { Accordion } from '#/components/Accordion/Accordion';
import { TextBadge } from '#/components/Badge/TextBadge';
import { DropdownChevron } from '#/components/Dropdown/Chevron/DropdownChevron';
import { Dropdown } from '#/components/Dropdown/Dropdown';
import { DropdownMenu } from '#/components/Dropdown/menus/Menu/DropdownMenu';
import { Icon } from '#/components/Icon/Icon';
import { Pill } from '#/components/Pill/Pill';
import { ScrollArea } from '#/components/ScrollArea/ScrollArea';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchRefinementDropdownHolder } from '#/modules/search/components/Refinement/Dropdown/SearchRefinementDropdown.styled';
import { useSearchRefinementsOverflow } from '#/modules/search/hooks/refinements/useSearchRefinementsOverflow';
import { spacing } from '#/theme/theme';

export function SearchRefinementsOverflowDropdown({
  children,
}: PropsWithChildren) {
  const { i18n } = useI18n();

  const { overflowRefinementsRef, selectedRefinementValues } =
    useSearchRefinementsOverflow();

  return (
    <SearchRefinementDropdownHolder
      id="overflow-dropdown"
      ref={overflowRefinementsRef}
      data-qa-id="search-refinements-overflow-dropdown"
    >
      <Dropdown
        trigger={
          <Pill
            size="medium"
            prefix={<Icon size={18} name="plus" />}
            suffix={<DropdownChevron size={16} />}
          >
            {i18n('More Filters')}{' '}
            <TextBadge content={selectedRefinementValues} />
          </Pill>
        }
      >
        <DropdownMenu
          offsetY={spacing[8]}
          placement="bottom-left"
          width="350px"
        >
          <Accordion>
            <ScrollArea
              height="calc(100vh - 211px)"
              direction="vertical"
              hideScrollBar
            >
              {children}
            </ScrollArea>
          </Accordion>
        </DropdownMenu>
      </Dropdown>
    </SearchRefinementDropdownHolder>
  );
}
